import { boolean, number, object } from "yup";

type Direction = "asc" | "desc";

export interface Sort<K extends PropertyKey> {
  field: K | string;
  direction: Direction;
}
export namespace Pageable {
  export interface T<K extends PropertyKey> {
    sorting?: Sort<K>;
    filters?: {
      field: K | string;
      value: string;
    }[];
    pagination?: {
      size: number;
      page: number;
    };
  }

  export function removeField<K extends X, X extends PropertyKey>(
    { sorting, filters, pagination }: T<X>,
    field: K
  ): T<Exclude<X, K>> {
    const newFilters = filters?.filter((x) => x.field !== field) as Array<{
      field: string | Exclude<X, K>;
      value: string;
    }>;

    return {
      pagination,
      filters: newFilters,
      ...(sorting?.field === field
        ? {}
        : { sorting: sorting as Sort<Exclude<X, K>> }),
    };
  }

  export function getQueryParam<K extends PropertyKey>({
    sorting,
    filters,
    pagination,
  }: T<K>) {
    let query = {};
    if (sorting) {
      query = {
        ...query,
        sort: `${String(sorting.field)},${sorting.direction || "asc"}`,
      };
    }
    // TODO: add filters
    if (pagination) {
      query = { ...query, size: pagination.size, page: pagination.page };
    }

    return query;
  }

  export namespace Response {
    export interface T {
      pageNumber: number;
      pageSize: number;
      totalElements: number;
      first: boolean;
      last: boolean;
      empty: boolean;
      sort: {
        sorted: boolean;
        unsorted: boolean;
        empty: boolean;
      };
    }

    export const validation = object().shape({
      pageNumber: number(),
      pageSize: number(),
      totalElements: number(),
      first: boolean(),
      last: boolean(),
      empty: boolean(),
      sort: object().shape({
        sorted: boolean(),
        unsorted: boolean(),
        empty: boolean(),
      }),
    });

    export const defaults: T = {
      pageNumber: 0,
      pageSize: 0,
      totalElements: 0,
      first: true,
      last: true,
      empty: true,
      sort: {
        sorted: false,
        unsorted: true,
        empty: true,
      },
    };
  }
}
